import { get, patch, post } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';
import { BuildingComplexesService } from '@/services/building-complexes.service';

export default {
  getItemsList({ commit }, { params } = {}) {
    return BuildingComplexesService.getList({
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  retrieveBuildingComplexesList: () => get('/building-complexes-list'),
  retrieveBuildingComplexesWithRelations: () =>
    get('/building-complexes-relations'),

  getBuildingComplexes({ commit }) {
    return get(`/booking/filters/building-complexes`).then(response => {
      commit('retrievedBuildingComplexes', response.data.data);

      return response;
    });
  },

  getBuildingComplexesList({ commit }, { params } = {}) {
    return get(`/building-complexes/list`, params).then(response => {
      commit('buildingComplexesList', response.data.data);

      return response;
    });
  },

  getCheckinBuildingComplex(_, buildingComplex) {
    return get(`/filters/building-complex/${buildingComplex}`).then(
      response => {
        return response;
      }
    );
  },

  retrieveBuildingComplex: (_, buildingComplex) =>
    get(`/building-complexes/${buildingComplex}`),

  store: (_, buildingComplex) => post('/building-complexes', buildingComplex),

  update: (_, buildingComplex) =>
    patch(`/building-complexes/${buildingComplex.id}`, buildingComplex),

  getFilteredBusinessCustomers(_, params) {
    return get(`/filters/building-complexes/business-customers`, params);
  },

  getFilteredManagementCompanies(_, params) {
    return get(`/filters/building-complexes/management-companies`, params);
  },

  getFilteredConcierges(_, params) {
    return get(`/filters/building-complexes/concierges`, params);
  },

  getTypes(_, params) {
    return get(`/filters/building-complexes/types`, params);
  },

  getStatuses(_, params) {
    return get(`/filters/building-complexes/statuses`, params);
  },

  getBuildings(_, buildingComplex) {
    return get(`/building-complexes/${buildingComplex}/buildings/list`);
  },
  getApartments(_, building) {
    return get(`/buildings/${building}/apartments/list`);
  }
};
